<template>
	<div class="warranty-list-in-warranty">
		<WarrantyListInWarrantyTableReact
			:repairs="data"
			:loading="loading"
			:onEntrance="performEntranceHandler"
		/>

		<WarrantyEntranceForm
			:repair="selectedRepair"
			:visibility.sync="dialogVisibility"
			@update="fetchRepairs"
		/>
	</div>
</template>

<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { WarrantyListInWarrantyTable } from "@/components/warranty/WarrantyListInWarrantyTable";
import WarrantyEntranceForm from "./warranty-entrance-form.vue";

const WarrantyListInWarrantyTableReact = ReactInVue(
	WarrantyListInWarrantyTable,
);

export default {
	name: "WarrantyListInWarranty",

	components: {
		WarrantyEntranceForm,
		WarrantyListInWarrantyTableReact,
	},

	data() {
		return {
			data: [],
			loading: true,
			entity: null,

			dialogVisibility: false,
			selectedRepair: null,
		};
	},

	created() {
		this.fetchRepairs();
	},

	methods: {
		async fetchRepairs() {
			this.loading = true;

			const { repairs } = await this.$stellar.action("getRepairByState", {
				state: "in_warranty",
			});
			this.data = repairs;

			this.loading = false;
		},

		performEntranceHandler(repair) {
			this.selectedRepair = repair;
			this.dialogVisibility = true;
		},
	},
};
</script>
